// extracted by mini-css-extract-plugin
export default {"mypage_subsc_payment":"method_mypage_subsc_payment__Md3fg"};